import React from 'react';
import classNames from 'classnames';
import { useFormikContext } from 'formik';

import type { EventType } from '../../services/EventType';
import Tracking from '../../services/Tracking';
import Loader from '../Loader';

interface Props {
  children: React.ReactNode;
  type?: 'submit' | 'button' | 'reset';
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  outline?: boolean;
  onClick?: () => boolean | unknown;
  track?: EventType | [EventType, ...UnsafeAny[]];
}

export default function FormikSubmitButton(props: Props) {
  const ctx = useFormikContext();
  return (
    <button
      className={classNames('btn', props.outline ? 'btn-outline-primary' : 'btn-primary', props.className)}
      disabled={props.disabled}
      onClick={event => {
        if (!ctx.isValid) {
          event.preventDefault();
          const firstErrorNode = document.querySelector('.is-invalid');
          if (firstErrorNode) {
            firstErrorNode.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
          }
          return true;
        }
        if (props.track) {
          const eventType = typeof props.track === 'string' ? props.track : props.track[0];
          const args = typeof props.track === 'string' ? [] : props.track.slice(1);
          Tracking.track(eventType, ...args);
        }
        if (!props.onClick) {
          if (ctx.isSubmitting || props.loading) {
            event.preventDefault();
            return true;
          }
          return;
        }

        const result = props.onClick();
        if (result === true) {
          event.preventDefault();
          return true;
        }
      }}
      type={props.type ?? 'submit'}
    >
      {ctx.isSubmitting || props.loading ? <Loader dotClassName="bg-white" /> : props.children}
    </button>
  );
}

export function SubmitButton(props: Props) {
  return (
    <button
      className={classNames('btn', props.outline ? 'btn-outline-primary' : 'btn-primary', props.className)}
      disabled={props.disabled}
      onClick={event => {
        if (!props.onClick) {
          if (props.loading) {
            event.preventDefault();
            return true;
          }
          return;
        }

        const result = props.onClick();
        if (result === true) {
          event.preventDefault();
          return true;
        }
      }}
      type={props.type ?? 'submit'}
    >
      {props.loading ? <Loader dotClassName="bg-white" /> : props.children}
    </button>
  );
}
